import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import LivePuzzleBoard from '../../components/LivePuzzleBoard/LivePuzzleBoard';
import { computePuzzleGrid } from '../../utils/puzzleGrid';
import { getPuzzleThemeConfig } from '../../utils/puzzleTheme';
import './big-picture.css';

export default function BigPicture() {
  const themeData = useSelector((state) => state.theme.data);
  const user = useSelector((state) => state.auth?.user);

  const sliceUrls = useMemo(() => {
    const config = getPuzzleThemeConfig(themeData);
    return config.slices ?? [];
  }, [themeData]);

  const { macroRows, macroCols } = useMemo(() => {
    const count =
      sliceUrls.length ||
      Math.floor(Number(themeData?.total_puzzles ?? themeData?.puzzle_parts)) ||
      9;
    const savedRows = Math.floor(Number(themeData?.row));
    const savedCols = Math.floor(Number(themeData?.col));
    if (
      Number.isFinite(savedRows) &&
      Number.isFinite(savedCols) &&
      savedRows * savedCols === count
    ) {
      return { macroRows: savedRows, macroCols: savedCols };
    }
    const grid = computePuzzleGrid(count);
    return { macroRows: grid.rows, macroCols: grid.cols };
  }, [sliceUrls.length, themeData?.row, themeData?.col, themeData?.total_puzzles, themeData?.puzzle_parts]);

  const { tileRows, tileCols } = useMemo(() => {
    const count = Math.floor(Number(themeData?.total_puzzles ?? themeData?.puzzle_parts)) || 9;
    const grid = computePuzzleGrid(count);
    return { tileRows: grid.rows, tileCols: grid.cols };
  }, [themeData?.total_puzzles, themeData?.puzzle_parts]);

  const title =
    String(themeData?.landing_page_title4 ?? themeData?.landing_title ?? 'Big Picture').trim() ||
    'Big Picture';

  const titleColor = themeData?.landing_page_title_color ?? themeData?.text_color ?? null;

  const pageStyle = useMemo(
    () => ({
      '--puzzle-title-color': titleColor || undefined,
      '--bp-macro-rows': macroRows,
      '--bp-macro-cols': macroCols,
    }),
    [titleColor, macroRows, macroCols]
  );

  useEffect(() => {
    document.body.classList.add('big-picture-active');
    return () => document.body.classList.remove('big-picture-active');
  }, []);

  return (
    <div className="big-picture-page" style={pageStyle}>
      <header className="big-picture-header">
        {/* <h1 className="big-picture-title">{title}</h1>
        <p className="big-picture-subtitle">Live team puzzle — updates as teammates place pieces</p> */}
        <h2 className="big-picture-banner">( Leave breakout room and go back to the meeting room )</h2>
      </header>

      <div className="big-picture-live-wrap">
        {sliceUrls.length > 0 ? (
          <LivePuzzleBoard
            sessionId={user?.sessionId}
            organizationId={user?.organizationId}
            sliceUrls={sliceUrls}
            macroRows={macroRows}
            macroCols={macroCols}
            tileRows={tileRows}
            tileCols={tileCols}
            currentUserId={user?.userId ? String(user.userId) : null}
            commaSeparateNames
          />
        ) : (
          <p className="big-picture-empty">Team puzzle preview unavailable</p>
        )}
      </div>
    </div>
  );
}
